import http from '../_http'

const detect = {
  //default
  listDetect: (m) => { return http.post(`manager/integrity/detect/list`, m); },
  detailDetect: (m) => { return http.get(`manager/integrity/detect/${m.id}`); },

  //crud
  insertDetect: (m) => { return http.post(`manager/integrity/detect`, m); },
  updateDetect: (m) => { return http.put(`manager/integrity/detect`, m); },
  deleteDetect: (m) => { return http.delete(`manager/integrity/detect/${m.id}`); },

  //action
  actionDetect: (m) => { return http.get(`manager/integrity/detect/action`, m); },
}

export default detect

export { detect }